import axiosInstance from '@/shared/api/axios';
import type { ApiPermissionsRegistry } from '@/shared/types/api/roles';

export const apiPermissionsRegistry = async (): Promise<ApiPermissionsRegistry> => {
  const { data } = await axiosInstance.get<ApiPermissionsRegistry>('/permissions/registry');
  return data;
};
